var gql = require("@apollo/client").gql;

const PROVIDERS_BY_GLOBAL_ID_QUERY = gql`
	query providersByGlobalId($globals_id_list: [Int!]!) {
		providersByGlobalId(globals_id_list: $globals_id_list) {
			data {
				name
				logo
			}
		}
	}
`;

export default PROVIDERS_BY_GLOBAL_ID_QUERY;
